import * as React from 'react'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useData, useHandlers } from './hooks'

type Props = {
  // SH-1428: hosts that own their own dismissal (e.g. the calendar Create Event
  // dialog) override cancel to close themselves; default keeps the popover-close
  // behavior for the existing entity-scoped callers.
  onCancelClick?: () => void
}

export function ActivityFormActions({ onCancelClick }: Props = {}) {
  const { handleCancelClick, handleSaveClick } = useHandlers()
  // SH-1428 (E5): disable Save while the form is invalid or a submit is
  // in flight to prevent double-submits — the value was already computed here
  // but never wired to the button.
  const { disableSave } = useData()
  const onCancel = onCancelClick ?? handleCancelClick

  return (
    <Stack direction="row" spacing={1} justifyContent="end" pt={2}>
      <Button
        fullWidth
        size="small"
        onClick={onCancel}
        data-test-id="activity-form-cancel-btn"
      >
        <Typography minWidth={110}>Cancel</Typography>
      </Button>
      <Button
        fullWidth
        size="small"
        variant="contained"
        onClick={handleSaveClick}
        disabled={disableSave}
        data-test-id="activity-form-save-btn"
      >
        <Typography minWidth={110}>Save</Typography>
      </Button>
    </Stack>
  )
}
